module.exports = __webpack_public_path__ + "media/talent/Moms-Kim-00ac0c25.png";